export const SCHEDULE_CLASSES_PAGE_TRACKINGS = {
  scheduleClasses: 'schedule_classes',
};
